import Migrator from '@/common/types/migrations/migrator';
import { GameSettings, VoiceSettings } from '@/common/types/student';

type LegacyGameSettings = Omit<GameSettings, 'voice'>;

type GameSettings_v1 = LegacyGameSettings & { voice: VoiceSettings };
function addVoiceSettings(old: LegacyGameSettings): GameSettings_v1 {
  return {
    ...old,
    voice: {
      accent: 'AUS',
      gender: 'male',
    },
  };
}

export const { migrate: migrateGameSettings, version: GAME_SETTINGS_VERSION } =
  new Migrator<GameSettings>({ 1: addVoiceSettings });
